import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, ChevronDown } from "lucide-react";
import rules from "@/data/rules.json";
import "@/components/HomeRules.css";

export default function Rules() {
    return <div className="wx-container wx-rules-page" data-testid="page-rules">
        <Link to="/" className="wx-rules-back"><ArrowLeft size={16} aria-hidden="true" /> Beranda</Link>
        <p className="wx-rules-eyebrow">SEBELUM CICI ORDER</p>
        <h1 className="font-serif wx-rules-title">Rules WxFaous</h1>
        <section className="wx-rules-deadline" aria-labelledby="payment-deadline-heading">
            <h2 id="payment-deadline-heading">{rules.deadline.title}</h2>
            <div className="wx-rules-deadline-countries">{rules.deadline.countries.map((country) => <div key={country.label}><span>{country.label}</span><strong>{country.duration}</strong></div>)}</div>
            <p>{rules.deadline.explanation}</p>
            <details className="wx-rules-deadline-more"><summary>Ketentuan pelunasan <ChevronDown size={14} aria-hidden="true" /></summary><p className="wx-rules-deadline-warning">{rules.deadline.warning}</p></details>
        </section>
        <div className="wx-rules-sections">{rules.sections.map((section) => <details key={section.id} id={section.id} className="wx-rule-section">
            <summary><h2 id={`${section.id}-heading`}>{section.title}</h2><ChevronDown size={18} aria-hidden="true" /></summary><div className="wx-rule-content">
            {section.accountBlock && <div className="wx-rules-account">{section.accountBlock.split("\n").map((line, index) => <p key={index} className={line === "BCA 8622327979" ? "wx-rules-bank-number" : ""}>{line || <br />}</p>)}</div>}
            <ul>{section.items.map((item, index) => <li key={index}>{item}</li>)}</ul>
        </div></details>)}</div>
        <div className="wx-rules-closing"><p>{rules.closing}</p><Link to="/order" className="wx-rules-link">Cek Pesanan <ArrowRight size={17} aria-hidden="true" /></Link></div>
    </div>;
}
